module.exports = __webpack_public_path__ + "img/4948872415095.a6c88da1.jpg";